import React, {} from 'react';
const styles = {"statement":"Statement-module__statement__61Hnw","line":"Statement-module__line__bnGT0"};
/** The centered serif statement under the hero, set lower so the hero's tilted pictures have room. */
export function Statement({ lines }) {
    return (React.createElement("p", { className: styles.statement }, lines.map((line, index) => (React.createElement("span", { key: index, className: styles.line }, line)))));
}
//# sourceMappingURL=Statement.js.map